import type { User } from "../empreenderUI/UserContext";
import { getStatusApp } from "../empreenderUI/lib/statusApp";

// Regra do atendimento humano (WhatsApp) por plano. DESLIGADA até decidir:
// - o que conta como "tem plano" (conta ativa, só plano pago, trial conta?);
// - se vale o plano do app escolhido na central ou o do Plus;
// - o que fazer com quem abre a central sem login no Plus.
// Esconder aqui é só visual: o bloqueio de verdade precisa existir no getwhatsapps da SAK.
export const REGRA_PLANO_ATIVA = false;

export type AcessoHumano = "liberado" | "sem_plano" | "verificando";

export const obterAcessoHumano = (user: User | null | undefined): AcessoHumano => {
  if (!REGRA_PLANO_ATIVA) return "liberado";
  if (user?.loading) return "verificando";
  if (!user?.current_store?.chave_empreender) return "sem_plano";

  return getStatusApp(user.current_store) === "expired" ? "sem_plano" : "liberado";
};
